import React from "react";

const Item = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_3199_717)">
        <rect
          x="4"
          y="4.32031"
          width="16"
          height="16.1264"
          rx="4"
          fill="#FFF4BA"
        />
      </g>
      <path
        d="M12.6856 10.4802L13.2856 11.085C13.3442 11.1441 13.4208 11.1736 13.4976 11.1736C13.5744 11.1736 13.6511 11.1441 13.7097 11.085L14.3097 10.4802C14.4268 10.3622 14.4268 10.1708 14.3097 10.0526L13.7097 9.44791C13.5926 9.32986 13.4027 9.32986 13.2855 9.44791L12.6855 10.0526C12.5684 10.1708 12.5684 10.3622 12.6856 10.4802H12.6856ZM13.4976 10.0893L13.6734 10.2665L13.4976 10.4436L13.3218 10.2665L13.4976 10.0893Z"
        fill="#B78400"
      />
      <path
        d="M11.7856 9.87402C11.8442 9.93314 11.9208 9.96264 11.9976 9.96264C12.0744 9.96264 12.1511 9.93314 12.2097 9.87402L12.8097 9.26928C12.9268 9.15123 12.9268 8.95983 12.8097 8.84171L12.2097 8.23697C12.0926 8.11893 11.9027 8.11893 11.7855 8.23697L11.1855 8.84171C11.0684 8.95976 11.0684 9.15117 11.1855 9.26928L11.7856 9.87402ZM11.9976 8.87836L12.1734 9.05553L11.9976 9.2327L11.8219 9.05553L11.9976 8.87836Z"
        fill="#B78400"
      />
      <path
        d="M14.7856 9.87402C14.8442 9.93314 14.9208 9.96264 14.9976 9.96264C15.0744 9.96264 15.1511 9.93314 15.2097 9.87402L15.8097 9.26928C15.9268 9.15123 15.9268 8.95983 15.8097 8.84171L15.2097 8.23697C15.0926 8.11893 14.9027 8.11893 14.7855 8.23697L14.1855 8.84171C14.0684 8.95976 14.0684 9.15117 14.1855 9.26928L14.7856 9.87402ZM14.9976 8.87836L15.1734 9.05553L14.9976 9.2327L14.8219 9.05553L14.9976 8.87836Z"
        fill="#B78400"
      />
      <path
        d="M8.78556 9.87402C8.84416 9.93314 8.92083 9.96264 8.99764 9.96264C9.07445 9.96264 9.15112 9.93314 9.20971 9.87402L9.80971 9.26928C9.92683 9.15123 9.92683 8.95983 9.80971 8.84171L9.20971 8.23697C9.09259 8.11893 8.90268 8.11893 8.7855 8.23697L8.1855 8.84171C8.06838 8.95976 8.06838 9.15117 8.1855 9.26928L8.78556 9.87402ZM8.99764 8.87836L9.17342 9.05553L8.99764 9.2327L8.82186 9.05553L8.99764 8.87836Z"
        fill="#B78400"
      />
      <path
        d="M12.8097 11.2597L12.2097 10.6549C12.0926 10.5369 11.9027 10.5369 11.7855 10.6549L11.1855 11.2597C11.0684 11.3777 11.0684 11.5691 11.1855 11.6872L11.7855 12.292C11.8442 12.351 11.9208 12.3805 11.9976 12.3805C12.0744 12.3805 12.1511 12.351 12.2097 12.2919L12.8097 11.6872C12.9269 11.5691 12.9269 11.3777 12.8097 11.2597V11.2597ZM11.9976 11.6506L11.8219 11.4734L11.9976 11.2963L12.1734 11.4734L11.9976 11.6506Z"
        fill="#B78400"
      />
      <path
        d="M9.68556 10.4802L10.2856 11.085C10.3442 11.1441 10.4208 11.1736 10.4976 11.1736C10.5744 11.1736 10.6511 11.1441 10.7097 11.085L11.3097 10.4802C11.4268 10.3622 11.4268 10.1708 11.3097 10.0526L10.7097 9.44791C10.5926 9.32986 10.4027 9.32986 10.2855 9.44791L9.68549 10.0526C9.56837 10.1708 9.56837 10.3622 9.68555 10.4802H9.68556ZM10.4976 10.0893L10.6734 10.2665L10.4976 10.4436L10.3218 10.2665L10.4976 10.0893Z"
        fill="#B78400"
      />
      <path
        d="M15.8977 10.5664C15.4013 10.5664 14.9977 10.9733 14.9977 11.4735V11.8273C14.9026 11.7934 14.8015 11.7759 14.6977 11.7759C14.4572 11.7759 14.2313 11.8702 14.0614 12.0417L13.1614 12.9488C12.9913 13.1201 12.8977 13.348 12.8977 13.5902V14.7996C12.7321 14.7996 12.5977 14.935 12.5977 15.102V16.3114C12.5977 16.4784 12.7321 16.6138 12.8977 16.6138H15.2977C15.4633 16.6138 15.5977 16.4784 15.5977 16.3114V15.102C15.5977 15.0507 15.5839 15.0034 15.5616 14.961L16.534 13.9809C16.704 13.8096 16.7977 13.5818 16.7977 13.3396V11.4735C16.7977 10.9733 16.394 10.5664 15.8977 10.5664L15.8977 10.5664ZM14.9977 16.0091H13.1977V15.4043H14.9977V16.0091ZM16.1977 13.3396C16.1977 13.4191 16.1656 13.497 16.1097 13.5533L14.8734 14.7996H13.4977V13.5902C13.4977 13.5095 13.5289 13.4335 13.5856 13.3763L14.4856 12.4692C14.5988 12.355 14.7958 12.3547 14.9095 12.469C14.9096 12.469 14.9096 12.4692 14.9097 12.4693C14.9665 12.5263 14.9977 12.6023 14.9977 12.683C14.9977 12.7637 14.9665 12.8396 14.9097 12.8966C14.7926 13.0146 14.7926 13.2063 14.9096 13.3243C14.9683 13.3834 15.0451 13.4129 15.1219 13.4129C15.1987 13.4129 15.2754 13.3834 15.334 13.3245C15.5041 13.153 15.5977 12.9253 15.5977 12.683V11.4735C15.5977 11.3067 15.7322 11.1711 15.8977 11.1711C16.0631 11.1711 16.1977 11.3067 16.1977 11.4735L16.1977 13.3396Z"
        fill="#B78400"
      />
      <path
        d="M11.0992 14.7996V13.5902C11.0992 13.3479 11.0056 13.1201 10.8355 12.9488L9.93551 12.0417C9.76555 11.8703 9.53968 11.7759 9.29922 11.7759C9.19542 11.7759 9.09431 11.7934 8.99922 11.8273V11.4735C8.99922 10.9733 8.59556 10.5664 8.09922 10.5664C7.60288 10.5664 7.19922 10.9733 7.19922 11.4735V13.3396C7.19922 13.5819 7.29283 13.8096 7.46293 13.9809L8.43525 14.961C8.41302 15.0034 8.39923 15.0507 8.39923 15.102V16.3114C8.39923 16.4783 8.53362 16.6138 8.69923 16.6138H11.0992C11.2648 16.6138 11.3992 16.4783 11.3992 16.3114V15.102C11.3992 14.935 11.2648 14.7996 11.0992 14.7996L11.0992 14.7996ZM7.79922 13.3396V11.4735C7.79922 11.3067 7.93375 11.1712 8.09922 11.1712C8.26469 11.1712 8.39922 11.3067 8.39922 11.4735V12.683C8.39922 12.9254 8.49283 13.153 8.66293 13.3245C8.72159 13.3834 8.79819 13.4129 8.875 13.4129C8.95181 13.4129 9.02862 13.3834 9.08728 13.3243C9.20427 13.2062 9.20427 13.0146 9.08715 12.8965C9.03043 12.8397 8.99922 12.7637 8.99922 12.683C8.99922 12.6023 9.03043 12.5264 9.08715 12.4694C9.08728 12.4693 9.08728 12.4691 9.08742 12.4689C9.20099 12.3549 9.39806 12.3551 9.51131 12.4692L10.4113 13.3763C10.468 13.4335 10.4992 13.5095 10.4992 13.5903V14.7996H9.12345L7.88716 13.5534C7.83131 13.497 7.79923 13.4192 7.79923 13.3396L7.79922 13.3396ZM10.7992 16.0091H8.99922V15.4043H10.7992V16.0091Z"
        fill="#B78400"
      />
      <defs>
        <filter
          id="filter0_d_3199_717"
          x="0"
          y="0.320312"
          width="24"
          height="24.125"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3199_717"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3199_717"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default Item;
